import { Stack, TitleGroup } from '@ekhodealer/ekho-common/rev';

import { BankAccountForm } from '../bank-account/BankAccountForm';

import { onboardingContent, OnboardingPage } from './content';

export function BankAccountPage() {
	const pageContent = onboardingContent[OnboardingPage.BankAccount];
	return (
		<Stack itemsSpacing='24' itemsAlignX='center'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>
			<BankAccountForm />
		</Stack>
	);
}
